<template lang="pug">
.container.mt-6
    .row: .col-lg-6.offset-lg-3
        .card.shadow-sm.p-md-4.mb-3(v-if="!verified")
            h2.mb-4 Passwort zurücksetzen
            form(@submit.prevent="requestPasswordResetToken")
                .form-group
                    label Ihre E-Mail-Adresse
                    input.form-control(v-model="username", required)
                    small.form-text.text-muted Wir senden Ihnen einen Passwort-zurücksetzen-Link.
                .d-flex.justify-content-between
                    router-link.btn.btn-link(to="/login") &laquo; Zurück zum Einloggen
                    button.btn.btn-primary(type="submit") Passwort zurücksetzen

        .card.shadow-sm.p-md-4.mb-3(v-else)
            .text-center(v-if="success")
                h2 Passwort erfolgreich geändert
                p Sie können Sich jetzt mit Ihrem neuen Passwort einloggen:
                router-link.btn.btn-primary(to="/login") Zum Login
            form(v-else, @submit.prevent="resetPassword")
                h2 Neues Passwort vergeben
                .form-group
                    label Neues Passwort
                    input.form-control(v-model="password", type="password", required)
                .form-group
                    label Neues Passwort wiederholen
                    input.form-control(v-model="password2", type="password", required)
                .text-right
                    button.btn.btn-primary(type="submit") Passwort speichern

    .text-center.small
        a(href="https://www.luftverbundrechner.de") LVR Webseite
        span.px-2 |
        a(href="https://www.luftverbundrechner.de/impressum") Impressum
        span.px-2 |
        a(href="https://www.luftverbundrechner.de/agb") AGB
        span.px-2 |
        a(href="https://www.luftverbundrechner.de/datenschutz") Datenschutz
</template>

<script>
import { userService } from '@/services'

export default {
    data () {
        return {
            username: '',
            verified: false,
            password: '',
            password2: '',
            success: false
        }
    },
    async created () {
        if (!this.$route.query.token) {
            return
        }

        try {
            await userService.verifyReset(this.$route.query.token)
            this.verified = true
        } catch (err) {
            this.verified = false
        }
    },
    methods: {
        async requestPasswordResetToken () {
            if (!this.username) {
                return
            }

            try {
                await userService.reset(this.username)
                this.$store.dispatch('alert/success', 'Ihnen wurde ein neues Passwort per E-Mail zugeschickt.', { root: true })
                // prevent double submissions
                this.username = ''
            } catch (err) {
                this.$store.dispatch('alert/error', 'Für diese E-Mail-Adresse konnten wir keinen Account finden', { root: true })
            }
        },
        async resetPassword () {
            if (this.password !== this.password2) {
                this.$store.dispatch('alert/error', 'Die beiden Passwörter stimmen nicht überein', { root: true })
                return
            }

            try {
                await userService.resetPassword(this.$route.query.token, this.password)
                this.success = true
            } catch (err) {
                this.$store.dispatch('alert/error', 'Das Passwort konnte nicht zurückgesetzt werden.', { root: true })
            }
        }
    }
}
</script>
